window.addEventListener('load', () => {
    const popup = document.querySelector<HTMLElement>(".SitePopupsComponent");
    if (!popup) return;
    const popup_id = popup.dataset.popupId;

    const open_toggles = popup.querySelectorAll<HTMLElement>("[data-popup-open]");
    const close_toggles = popup.querySelectorAll<HTMLElement>("[data-popup-close]");

    let initial_timeout: number;

    function hasPopupCookie() {
        return !!sessionStorage.getItem(`popup-closed-${popup_id}`);
    }

    function setPopupCookie() {
        sessionStorage.setItem(`popup-closed-${popup_id}`, 'true');
    }

    function removePopupCookie() {
        sessionStorage.removeItem(`popup-closed-${popup_id}`);
    }

    function open() {
        popup.classList.remove('closed');
        removePopupCookie();
        if (initial_timeout) {
            clearTimeout(initial_timeout);
        }
    }

    function close() {
        popup.classList.add('closed');
        setPopupCookie();
        if (initial_timeout) {
            clearTimeout(initial_timeout);
        }
    }

    open_toggles.forEach((toggleBtn) => {
        toggleBtn.addEventListener('click', (e) => {
            e.preventDefault();
            open();
        });
    });

    close_toggles.forEach((toggleBtn) => {
        toggleBtn.addEventListener('click', (e) => {
            e.preventDefault();
            close();
        });
    });

    setTimeout(() => {
        // show the open button after 500ms
        popup.classList.remove('hide-closed');
    }, 500);

    // auto open after 5 seconds if no cookie
    if (!hasPopupCookie()) {
        initial_timeout = setTimeout(open, 5000);
    }

    // close on escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !popup.classList.contains('closed')) {
            close();
        }
    });
});
